import React from 'react'
import { Typography, Chip, CircularProgress, IconButton, Tooltip } from '@material-ui/core'
import {
  CallSplit as ConvertIcon,
  Archive as ArchiveIcon,
  DeleteOutline as DeleteIcon,
  AttachFile as AttachIcon,
} from '@material-ui/icons'

const STATUS_FILTERS = ['open', 'converted', 'archived']

const truncate = (str, len) => {
  if (!str) return ''
  return str.length > len ? str.slice(0, len) + '...' : str
}

const CapturesTab = ({ items, loading, statusFilter, onChangeFilter, onConvert, onArchive, onDelete }) => {
  return (
    <div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
        {STATUS_FILTERS.map(s => (
          <Chip
            key={s}
            label={s}
            size="small"
            color={statusFilter === s ? 'primary' : 'default'}
            onClick={() => onChangeFilter(s)}
            style={{ height: 22, fontSize: 11, textTransform: 'capitalize' }}
          />
        ))}
      </div>

      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}>
          <CircularProgress size={20} />
        </div>
      )}

      {!loading && items.length === 0 && (
        <Typography variant="body2" color="textSecondary" style={{ padding: 24, textAlign: 'center' }}>
          No {statusFilter} captures. Use the Quick Capture button to jot a thought.
        </Typography>
      )}

      {!loading && items.map((cap) => (
        <div
          key={cap._id}
          style={{ padding: '10px 0', borderBottom: '1px solid var(--line-1, #eee)' }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {truncate(cap.body, 200)}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 4 }}>
                {cap.scopeLabel && (
                  <Chip label={cap.scopeLabel} size="small" variant="outlined" style={{ height: 18, fontSize: 10 }} />
                )}
                {cap.attachments && cap.attachments.length > 0 && (
                  <span style={{ display: 'flex', alignItems: 'center', fontSize: 11, color: 'var(--ink-3)' }}>
                    <AttachIcon style={{ fontSize: 13, marginRight: 2 }} />
                    {cap.attachments.length}
                  </span>
                )}
              </div>
            </div>
            <div style={{ display: 'flex', flexShrink: 0 }}>
              {cap.status === 'open' && (
                <>
                  <Tooltip title="Convert to context">
                    <IconButton size="small" onClick={() => onConvert(cap)}>
                      <ConvertIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Archive">
                    <IconButton size="small" onClick={() => onArchive(cap)}>
                      <ArchiveIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </>
              )}
              {/* Delete is always available so archived/converted captures are never stranded. */}
              <Tooltip title="Delete">
                <IconButton size="small" onClick={() => onDelete(cap)}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default CapturesTab
